import React from "react";
import Modal from "components/modal";

const ConfirmNoConferenceLinkModal = ({ isOpen, onCancel, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      className="confirmation-modal"
      type="confirm-dialog"
      submitBtnText="Confirm"
      cancelBtnText="Cancel"
      onCancel={onCancel}
      onSubmit={onConfirm}
      autoFocusSubmit={false}
    >
      <div className="react-dialog-confirm-msg">
        You didn't enter a conference link. Are you sure you want to proceed?
      </div>
    </Modal>
  );
};

export default ConfirmNoConferenceLinkModal;
